import { motion } from "framer-motion";
import { Droplets, Wind, HandHeart, BadgeCheck, MapPin, Sparkles } from "lucide-react";
import { IMAGES } from "@/lib/content";

const POINTS = [
  { icon: Droplets, title: "Deep Steam Extraction", text: "Powerful portable hot-water extraction lifts embedded dirt, allergens and stains most machines leave behind." },
  { icon: Wind, title: "Fast Dry Times", text: "High-powered vacuum recovery means carpets are back to walkable in as little as 1–2 hours." },
  { icon: HandHeart, title: "Pet & Family Safe", text: "Eco-conscious, non-toxic solutions that are safe around children and pets." },
  { icon: BadgeCheck, title: "Honest, Upfront Pricing", text: "Clear quotes with no hidden fees or high-pressure upsells. What we quote is what you pay." },
  { icon: MapPin, title: "Local Okanagan Team", text: "Kelowna owned and operated. We know the area and treat every home like our own." },
  { icon: Sparkles, title: "Satisfaction Guarantee", text: "Not happy with a spot? We'll come back and re-clean it free of charge." },
];

export default function WhyUs() {
  return (
    <section id="why" data-testid="why-section" className="py-20 md:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="label-caps mb-4">Why Kelowna Trusts Us</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1A2A5E]">
            The difference is in the details.
          </h2>
          <p className="mt-4 text-[#475569] text-lg leading-relaxed">
            We built our reputation on doing the job properly — powerful equipment, proven methods and
            genuinely honest service from a team that lives right here in the Okanagan.
          </p>
          <div className="mt-8 rounded-sm overflow-hidden border border-[#E2E8F0] shadow-lg">
            <img src={IMAGES.kelowna} alt="Kelowna Okanagan lake and mountains" className="w-full h-64 object-cover" />
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`why-point-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 2) * 0.08 }}
              className="bg-white border border-[#E2E8F0] rounded-sm p-6 hover:shadow-lg transition-shadow"
            >
              <div className="w-11 h-11 bg-[#EEF2FB] text-[#2B4BB8] rounded-sm flex items-center justify-center mb-4">
                <p.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display text-lg font-bold text-[#0F172A]">{p.title}</h3>
              <p className="mt-2 text-sm text-[#475569] leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
